// extracted by mini-css-extract-plugin
export default {"container":"acc_2XfkR","button":"acc_but_3tksu","icon":"acc_ico_1UK99","wrapper":"acc_wra_38k_","collapsed":"acc_col_fea8N"};